var map = {
	"./en.json": 44174,
	"./es.json": 46725,
	"./hi.json": 53134,
	"./id.json": 35176,
	"./ja.json": 87980,
	"./ko.json": 19423,
	"./pt.json": 37741,
	"./ru.json": 74600,
	"./th.json": 67549,
	"./vi.json": 91496,
	"./zh-Hant.json": 63531,
	"./zh.json": 79527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35679;